import React, { HTMLAttributes, useContext } from 'react';
import c from 'classnames';
import { CommentContext } from '../../CommentContext';
import { CommentableTypes } from '../../redux/types';
import s from './ContentBox.scss';

export interface Props extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

/**
 * The padding and background for the main content of a comment.
 *
 * We tend to put the byline and text content in one of these.
 */
const ContentBox: React.FC<Props> = ({ children, className, ...rest }) => {
  const { comment } = useContext(CommentContext);
  const { isFeatured } = comment;
  return (
    <div
      className={c(
        s['root'],
        'ds-surface-secondary',
        isFeatured && s['featured'],
        className,
        comment.typeId === CommentableTypes.COMMENT_DEVIATION && s['deviation']
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
ContentBox.displayName = 'ContentBox';

export default ContentBox;
